document.addEventListener('DOMContentLoaded', () => {
    const page = document.querySelector('.myaccount');
    if (!page) return;

    function activate(key, root) {
        root.querySelectorAll('[data-pay-subtab]').forEach((s) => {
            const isOn = s.dataset.paySubtab === key;
            s.classList.toggle('is-active', isOn);
            s.setAttribute('aria-selected', isOn ? 'true' : 'false');
        });

        root.querySelectorAll('[data-pay-panel]').forEach((p) => {
            p.hidden = p.dataset.payPanel !== key;
        });
    }

    page.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-pay-subtab]');
        if (!btn) return;
        e.preventDefault();

        const key = btn.dataset.paySubtab;
        if (!key) return;

        activate(key, btn.closest('.myaccount__payments') || page);
    });

    // Deep link: /myaccount?tab=payments&pay=<subtab> opens that sub-tab.
    const deepLink = new URLSearchParams(window.location.search).get('pay');
    if (deepLink && page.querySelector(`[data-pay-subtab="${CSS.escape(deepLink)}"]`)) {
        const root = page.querySelector('.myaccount__payments') || page;
        activate(deepLink, root);
    }
});
